interface ModalProps {
  message: string; // Prop para el texto del placeholder
  titel: string;
  textButton: string;
  onClick: () => void; // Prop para la función
}

const Modal = ({ message, titel, textButton, onClick }: ModalProps) => {
  return (
    <div className="fixed top-0 left-0 w-screen h-screen flex items-center justify-center bg-black bg-opacity-50 z-50">
      <div className="bg-white p-6 rounded-lg shadow-lg text-center w-80">
        <h2 className="text-2xl font-bold mb-4">{titel}</h2>
        <p className="mb-6">{message}</p>
        <button
          onClick={onClick}
          className="bg-blue-500 hover:bg-blue-700 text-white font-bold py-2 px-4 rounded"
        >
          {textButton}
        </button>
      </div>
    </div>
  );
};

export default Modal;
